import { Link } from "react-router-dom";
import { imgUrl, money0 } from "@/lib/api";
import { quote } from "@/lib/fees";
import { Rating } from "@/components/Reviews";
import { ImageOff } from "lucide-react";

export default function ListingCard({ l, nights = 0, large = false }) {
  const q = quote(l.price_per_night, l.cleaning_fee, nights || 1);
  return (
    <Link to={`/listings/${l.listing_id}`} data-testid={`listing-card-${l.listing_id}`} className="group block transition-transform duration-300 hover:-translate-y-1">
      <div className={`relative overflow-hidden rounded-2xl bg-stone-100 shadow-sm transition-shadow duration-300 group-hover:shadow-2xl group-hover:shadow-stone-900/15 ${large ? "aspect-[4/3] md:aspect-[16/11]" : "aspect-[4/3]"}`}>
        {l.photos?.[0] ? (
          <img src={imgUrl(l.photos[0])} alt={l.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        ) : (
          <div className="grid h-full place-items-center text-stone-400"><ImageOff /></div>
        )}
        <span className="absolute left-3 top-3 rounded-full border border-emerald-200 bg-emerald-50/95 px-3 py-1 text-xs font-semibold text-emerald-700" data-testid="listing-card-savings">
          No guest service fee
        </span>
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-stone-950/60 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <span className="absolute bottom-3 right-3 rounded-full bg-stone-950/85 px-3 py-1 font-mono-num text-sm font-semibold text-white backdrop-blur-md" data-testid="listing-card-price-chip">
          {money0(l.price_per_night)}<span className="font-sans text-xs font-normal text-white/70"> /night</span>
        </span>
      </div>
      <div className="mt-3 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="truncate font-semibold text-stone-900">{l.title}</h3>
          <p className="truncate text-sm text-stone-500">{l.location} · {l.max_guests} guests</p>
        </div>
        <Rating value={l.rating} count={l.review_count} />
      </div>
      <p className="mt-1 text-sm">
        <span className="font-mono-num font-semibold">{money0(l.price_per_night)}</span> night
        {nights > 0 && <span className="text-stone-500"> · {money0(q.total)} total before any lodging tax</span>}
      </p>
    </Link>
  );
}
